<template>
  <div id="healthFactors">
    <!-- Titulo -->
    <div class="d-flex align-items-center justify-content-start">
      <img class="centerImg1 mr-3" src="@/assets/images/icons/stethoscope.svg" width="25px">
      <h3 class="font-weight-bold m-0">Factores de Salud</h3>
    </div>
    <!-- Final -->

    <!-- Agregar factor de salud -->
    <div v-if="can('17')"
         class="mt-5 p-0 col-12 d-flex align-items-center justify-content-between">
        <button @click="newDiagnostic"
                class="btn-create new-responsive">
          <p class="m-0 pr-2 d-flex align-items-center">
            Agregar nuevo diagnostico <span>+</span>
          </p>
        </button>
    </div>
    <!-- final -->

    <!-- factores de salud -->
    <div v-if="dataUser.regular[0] || dataUser.occupational[0]"
         class="d-flex m-0 col-12 justify-content-between mt-5">
      <!-- origen laboral -->
      <div class="shadow table-diagnostics col-6 mr-3 p-0">
        <div class="header">
          <p class="m-0">
            Origen Laboral
          </p>
        </div>
        <div class="p-3">
          <b-table :items="tableOccupational.items"
                   :fields="tableOccupational.fields">
            <template #cell(date)="row">
              <div class="d-flex justify-content-between">
                <div>
                  {{ row.item.date.date }}
                </div>
                <router-link :to="'/diagnostic/' + row.item.date.id">
                  <span class="icon-eye ml-3 icon" style="font-size:16px;color:#2E5AAC"></span>
                </router-link>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <!-- final -->
      <!-- Origen Común -->
      <div class="shadow table-diagnostics col-6 ml-3 p-0">
        <div class="header">
          <p class="m-0">Origen Común</p>
        </div>
        <b-table :items="tableRegular.items"
                 :fields="tableRegular.fields">
          <template #cell(date)="row">
            <div class="d-flex justify-content-between">
              <div>
                {{ row.item.date.date }}
              </div>
              <router-link :to="'/diagnostic/' + row.item.date.id">
                <span class="icon-eye ml-3 icon" style="font-size:16px;color:#2E5AAC"></span>
              </router-link>
            </div>
          </template>
        </b-table>
      </div>
      <!-- final -->
    </div>
    <div v-else>
      <p class="my-5">
        No hay ningun diagnostico registrado.
      </p>
    </div>
    <!-- final -->
  </div>
</template>

<script>
import {
  mapActions
} from 'vuex'

export default {
    name: "healthFactors",
    props: {
        dataUser:{},
    },
    data() {
        return {
            tableOccupational:{
                fields:[],
                items:[]
            },
            tableRegular:{
                fields:[],
                items:[]
            },
        }
    },
    computed: {
      status_options () {
        return {
          'Qualified': 'Calificada / En firme',
          'controversy': 'Controversia',
          'study': 'En estudio'
        }
      }
    },
    beforeMount(){
        this.loadRows()
    },
    methods: {
      ...mapActions("modDiagnostics", [
          'actNewDiagnosticFromOtherComponent'
      ]),
      loadRows(){
        this.tableOccupational.items = [];
        this.tableOccupational.fields = [
            {
              key: 'diagnostic',
              label: 'Diagnóstico'
            },
            {
              key:'status',
              label: 'Estado',
            },{
              key: 'date',
              label:'Fecha de calificación'
            }
        ];
        this.dataUser.occupational.forEach(x => {
          let date = {
            date:x.qualification_date,
            id:x.id
          }
          let status = ''
          if (this.status_options[x.status]) { status = this.status_options[x.status] }
          this.tableOccupational.items.push({
            diagnostic:x.diagnosis,
            status:status,
            date:date
          })
        });

      //   Tabla Regular
      this.tableRegular.items = [];
      this.tableRegular.fields = [
            {
              key: 'diagnostic',
              label: 'Diagnóstico'
            },
            {
              key:'status',
              label: 'Estado',
            },{
              key: 'date',
              label:'Fecha de calificación'
            }
        ];
      this.dataUser.regular.forEach(x => {
        let date = {
          date:x.qualification_date,
          id:x.id
        }
        let status = ''
        if (this.status_options[x.status]) { status = this.status_options[x.status] }
                /*switch (x.status) {
                    case 'Qualified':
                        status = 'Calificada / En firme'
                        break;
                    case 'controversy':
                        status = 'Controversia'
                        break;
                    case 'study':
                        status = 'En estudio'
                        break;
                    default:
                        break;
                  } */
        this.tableRegular.items.push({
            diagnostic:x.diagnosis,
            status:status,
            date:date
          })
        });
      },
      newDiagnostic(){
          this.actNewDiagnosticFromOtherComponent(true)
          this.$router.push({ path: '/sve' });
      }
    },

}
</script>

<style lang="scss">
#healthFactors{
    .header{
        background-color: #F5F5F5;
        font-size: 15px;
        font-weight: 800;
        padding: 10px;
        margin: 0;
        font-family: Open Sans;
    }
    .table-diagnostics {
    font-family: Open Sans;
    font-size: 14px;
    font-style: normal;
    text-align: left;
    font-weight: 100;
    thead {
      background-color: #eef2fa;
      border-radius: 10px;
      border: none;
      th {
        border: none;

      }
    }
    tbody{
        background-color: white;
        tr{
        border:none;
        font-size: 13px;
      }
    }
    .theading {
      padding: 15px 15px;
    }
  }
  .icon{
        cursor: pointer;
    }
}
</style>